import { createFileRoute } from '@tanstack/react-router';

import { PortalSubscriptionPage } from '@/modules/portal/pages/PortalSubscriptionPage';

export const Route = createFileRoute('/portal/subscription/')({
  component: PortalSubscriptionPage,
});
